import React from 'react';
import { Link } from 'react-router-dom';
import logoPrimary from '../../assets/images/eb/logo-primary.png';
import logoReversed from '../../assets/images/eb/logo-reversed.png';
import ethosboardIcon from '../../assets/images/ethosboard_icon.png';

/**
 * variant="light" → full-colour logo (for white/cream backgrounds)
 * variant="dark"  → reversed logo (for Deep Forest / dark backgrounds)
 * The props from the previous version are still accepted so existing pages keep working.
 */
const LandingLogo = ({ to = '/', variant = 'light', layout = 'lockup', size = 'md', className = '' }) => {
  const heights = { sm: 24, md: 28, lg: 40 };
  const height = heights[size] || heights.md;
  const useIcon = layout === 'logo-only';
  const src = useIcon ? ethosboardIcon : variant === 'dark' ? logoReversed : logoPrimary;

  const img = (
    <img
      src={src}
      alt="EthosBoard"
      className={`landing-brand-logo-img object-contain ${className}`}
      style={{ height, width: 'auto', maxWidth: useIcon ? height * 1.15 : 220, display: 'block' }}
    />
  );

  if (to) {
    return (
      <Link to={to} className="landing-brand-link" aria-label="EthosBoard home">
        {img}
      </Link>
    );
  }
  return img;
};

export default LandingLogo;
